import { Grid } from "@mui/material";
import { FormSection } from "Components/Shared/FormSection";
import { GridItem } from "Components/Shared/GridItem";
import type { PartyDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import { formatDate } from "Utils/DateUtils";

const FIELD_RESOURCES =
  Resources.Pages.Content.UserDetailPageContent.Tabs.RelatedParties.Form.Fields
    .RelatedPartyFields;
const IDENTIFICATION_RESOURCES =
  Resources.Pages.Content.UserDetailPageContent.Tabs.Party.Form
    .PartyIdentification;
const EXPIRATION_RESOURCES = Resources.Components.DocumentExpirationWarning;

type Props = {
  partyData: PartyDto;
};

export const DocumentValidityInfo = ({ partyData }: Props) => {
  const { t } = useResource();
  const identification = partyData.partyIdentification;
  const primaryValidTo = identification?.identificationValidTo;
  const secondaryValidTo = identification?.secondIdentificationValidTo;

  if (!primaryValidTo && !secondaryValidTo) {
    return null;
  }

  return (
    <FormSection legend={t(FIELD_RESOURCES.Legend.Documents)} noMargins>
      <Grid container spacing={2}>
        {primaryValidTo && (
          <GridItem
            label={t(IDENTIFICATION_RESOURCES.IdentificationValidTo)}
            value={formatDate(primaryValidTo)}
          />
        )}
        {secondaryValidTo && (
          <GridItem
            label={t(EXPIRATION_RESOURCES.SecondDocumentValidTo)}
            value={formatDate(secondaryValidTo)}
          />
        )}
      </Grid>
    </FormSection>
  );
};
